module.exports = __webpack_public_path__ + "static/bricks-b5ebd79c03bd2295e5d939edb012c623.jpg";